module.exports = __webpack_public_path__ + "static/media/3.74d669d2.png";